export enum UniswapEventName {
  BalancesReport = 'Balances Report',
  TokenSelected = 'Token Selected',
}
